<div class="row page-header">
    <div class="col-12">
        <h1>Safety Meetings <small>Schedule safety meetings and view attendees</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Code'" [binding]="'id'" [cssClass]="'cell-img'" [width]="75">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <wj-barcode-qr-code
                                    class="qr-code"
                                    style="z-index: 10"
                                    [style.width]="qrSize + 'px'"
                                    [style.height]="qrSize + 'px'"
                                    [value]="getQrCodeUrl(cell.item.id)"
                                    (click)="toggleFullScreenQr(cell.item.id, true)"
                                >
                                </wj-barcode-qr-code>
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Title'" [binding]="'title'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'2*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
<div appAutoSize class="qr-fullscreen" [hidden]="!showFullScreenQr" (click)="toggleFullScreenQr('', false)">
    <wj-barcode-qr-code class="full-qr-code" style="width: 100%" [value]="fullScreenQr"> </wj-barcode-qr-code>
    <a href="javascript:void(0)" (click)="openMeeting()">Link</a>
</div>
